module.exports = __webpack_public_path__ + "static/img/company-component-cove-10-1.edb26684.jpg";